<template>
    <div id="appDetail">
      <div class="midCommon">
        <div>
          <div class="contentBox">
            <div class="title" v-html="data.title"></div>
            <div class="more" v-if="data.modelId !== 'shi_wu'">
              <div
                class="time"
                v-if="data.attribute&&data.attribute.source"
              >
                来源:{{ data.attribute.source }}
              </div>
              <div class="time" v-if="data.modelId == 'xggd' && data.author">
                作者:{{ data.author }}
              </div>
              <div
                class="time"
                v-if="
                  (data.modelId == 'dayi' || data.modelId == 'jiedu') &&
                  data.author
                "
              >
                发文单位:{{ data.author }}
              </div>
              <div
                class="time"
                v-if="
                  data.author &&
                  data.modelId != 'xggd' &&
                  data.modelId != 'dayi' &&
                  data.modelId != 'jiedu'
                "
              >
                发文机关:<span v-html="data.author"></span>
              </div>
              <div class="time" v-if="data.editor">
                发文文号:<span v-html="data.editor"></span>
              </div>
              <div class="time" v-if="data.publishDate">
                发文日期:{{ data.publishDate | publishDate }}
              </div>
  
              <!-- <div class="time" v-if="data.attribute&&data.attribute.state">文件效力:{{data.attribute.state | typeFil(that)}}</div> -->
              <div class="time" v-if="data.xlfwName">
                文件效力:{{ data.xlfwName }}
              </div>
            </div>
            <div class="more" v-if="data.modelId == 'shi_wu'">
              <div class="time" v-if="data.attribute && data.attribute.fwdw">
                发文机关:<span v-html="data.attribute.fwdw"></span>
              </div>
              <div class="time" v-if="data.editor">
                发文文号:<span v-html="data.editor"></span>
              </div>
              <div class="time" v-if="data.publishDate">
                发文日期:{{ data.publishDate | publishDate }}
              </div>
              <div class="time" v-if="data.attribute && data.attribute.state">
                文件效力:{{ data.attribute.state | typeFil }}
              </div>
              <div class="time" v-if="data.attribute && data.attribute.source">
                来源:<span v-html="data.attribute.source"></span>
              </div>
              <div class="time" v-if="data.author">
                作者:<span v-html="data.author"></span>
              </div>
            </div>
            <div class="text" id="text" v-html="imgUrl(data.text)"></div>
            <div
              style="
                padding-top: 16px;
                border-top: 2px solid #d8d8d8;
                font-size: 18px;
                color: #3d3d3d;
              "
              v-if="listId == 4023"
            >
              提示：本文章仅供学习参考，如有侵权请联系删除。
            </div>
            <div
              style="
                padding-top: 16px;
                border-top: 2px solid #d8d8d8;
                font-size: 18px;
                color: #3d3d3d;
              "
              v-if="listId == 4027"
            >
              提示：该答复仅供参考。
            </div>
            <!-- <div
              class="vipText"
              v-if="
                !$store.state.user.id
              "
            >
              ------------以下内容省略若干行,请<span @click="loginFun(true)">登录</span
              >后查看------------
            </div> -->
            <div
              class="vipText"
              v-if="
                $store.state.user.id&&
                ($store.state.user.vipInfo == null ||
                $store.state.user.vipInfo.isVip != 1)
              "
            >
              ------------以下内容省略若干行,请<span @click="vipFun">续费VIP</span
              >后查看------------
            </div>
            <div
              v-if="
                $store.state.user.vipInfo != null &&
                $store.state.user.vipInfo.isVip == 1
              "
            >
              <div
                class="typeBoxs"
                v-if="data.FilesInfo && data.FilesInfo.length > 0"
              >
                <div class="accessory">
                  <span style="margin-left: 14px"> 附件:</span>
                </div>
                <div class="titleBox" v-for="item in data.FilesInfo">
                  <span
                    class="title"
                    style="cursor: pointer"
                    @click="download(item, 1)"
                    >{{ item.title }}</span
                  >
                  <span
                    @click="download(item, 2)"
                    class="btn"
                    style="cursor: pointer"
                    v-if="item.contentFilePath"
                    >下载</span
                  >
                  <span
                    @click="download(item, 1)"
                    class="btn"
                    style="cursor: pointer"
                    v-else
                    >查看</span
                  >
                </div>
              </div>
              <div class="typeBoxs" v-if="data.JDInfo && data.JDInfo.length > 0">
                <div class="accessory">
                  <span style="margin-left: 14px">相关解读:</span>
                </div>
                <div
                  class="titleBox"
                  v-for="item in data.JDInfo"
                  @click="jumpC(item.id)"
                >
                  <span class="title" style="cursor: pointer">{{
                    item.title
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  var allThis = ''
  import { newInspectListDetail, HomeAnalyzeKeyword } from '@/api/api'
  
  
    //新加的检索框的引入数据
    import linkJS from '@/config/link'
    const loginLink = linkJS[process.env.NODE_ENV]['loginLink']
    
    import { login } from '@/api/api'
  
  
  export default {
    props:['sendData'],
    data() {
      return {
        nav: false,
        type: ['有效', '失效', '部分失效', '-', '时效性'],
        id: this.$route.query.contentId,
        keyWord: this.$route.query.keyWord,
        data: {},
        loading: '',
        that: this,
        tag: [],
        listId: this.$route.query.listId,
      }
    },
    mounted() {
      allThis = this;
      //获取id 参数传递进来的
      this.id = this.$props.sendData.id;
        //console.log(this.id);
      //console.log(this.$store.state.user)
      //this.HomeAnalyzeKeyword()
      this.Cmsdetail()
   
    },
    filters: {
      publishDate(v) {
        var date = new Date(v) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-'
        var M =
          (date.getMonth() + 1 < 10
            ? '0' + (date.getMonth() + 1)
            : date.getMonth() + 1) + '-'
        var D =
          (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
        var h =
          (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
        var m =
          (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
          ':'
        var s =
          date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
        return Y + M + D
        //return Y+M+D+h+m+s;
      },
      typeFil(v, that) {
        //that为空 不知道为啥 加个判断 为空时获取别的
        if (that) {
          return that.type[v - 1]
        } else {
          return allThis.type[v - 1]
        }
      },
    },
    methods: {
      loginFun(v) {
          login().then((res) => {
            if (res.data.status == 401) {
              // 判断是点击登录按钮还是生命周期调用
              if (v) {
                //登录
                let thatUrl = location.href
                let url = encodeURIComponent(thatUrl)
                window.location.href = loginLink + '' + url
              } else {
                //console.log('未登录')
                let user = {
                  vipInfo: {
                    isVip: 0,
                  },
                  loginBol: true,
                }
                this.$store.commit('setUser', user)
                //console.log(this.$store.state.user)
              }
            } else {
              console.log('已登录', res)
              this.user = res.data.data
              console.log(this.$store.state.user)
              this.$store.commit('setUser', this.user)
              console.log(this.$store.state.user)
  
              this.userInfo = res.data.data;
              // this.userInfo['isVip'] = res.data.data.vip;
              //存储用户信息
              sessionStorage.setItem("userInfoData",JSON.stringify(this.userInfo));
            }
          })
        },
      vipFun() {
        window.open(
          'http://zsdy-mall-pc.bjzsdy.com/goodsType?appCode=taxlaw',
          '_blank'
        )
      },
      jump(v) {
        let url = process.env.VUE_APP_ZSG_URL + v
        window.open(url, '_blank')
      },
      imgUrl(v) {
        let a = v
        let b = new RegExp('src="/webfile/', 'g')
        if (a) {
          a = a.replace(b, 'src="/webfile/')
        }
        return a
      },
      download(v, k) {
        if (k == 2) {
          if (v.contentFilePath) {
            let src = '/webfile/' + v.contentFilePath
            var $a = document.createElement('a')
            $a.setAttribute('href', src)
            $a.setAttribute('download', v.fileName ? v.fileName : '')
            var evObj = document.createEvent('MouseEvents')
            evObj.initMouseEvent(
              'click',
              true,
              true,
              window,
              0,
              0,
              0,
              0,
              0,
              false,
              false,
              true,
              false,
              0,
              null
            )
            $a.dispatchEvent(evObj)
          } else {
            this.$message({
              message: '当前附件未上传可下载文件！！！',
              type: 'warning',
            })
          }
        } else {
          let Detail = this.$router.resolve({
            path: '/filesInfo',
            query: { contentId: v.id },
          })
          window.open(Detail.href, '_blank')
        }
      },
      jumpC(v) {
        let Detail = this.$router.resolve({
          path: '/content',
          query: {
            contentId: v,
            keyWord: this.keyWord,
            contentIds: this.contentIds,
          },
        })
        window.open(Detail.href, '_blank')
      },
      HomeAnalyzeKeyword() {
        this.tag = []
        let data = {
          keyword: this.keyWord,
        }
        HomeAnalyzeKeyword(data).then((res) => {
          console.log(res.data.data, 'dddd')
          this.tag = res.data.data
        })
      },
      Cmsdetail() {
        this.loading = this.$loading({
          lock: true,
          text: '拼命加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        let data = {
          contentIds:[''],
          id: this.id ,
          keyWords: [''],
          tagIds:[32500],
          // keyWords:this.tag.length==0?[this.keyWord.trim()]:this.tag
        }
        newInspectListDetail(data).then((res) => {
          //console.log(res)
          let text = res.data.data.text
          this.data = res.data.data
          if (text.indexOf('id="mhfont"') != -1) {
            this.$forceUpdate()
            this.data.text = text.replace('id="mhfont"', 'id="mhfont1"')
            // setTimeout(() => {
            this.$forceUpdate()
            setTimeout(() => {
              this.$nextTick(() => {
                document.getElementById('mhfont1').scrollIntoView()
              })
            }, 500)
  
            // }, 2000)
          }
          let that = this
          setTimeout(function () {
            //描蓝 法规跳法规
            that.$nextTick(function () {
              that.addStyle()
            })
          }, 300)
  
          this.loading.close()
        })
      },
      addStyle() {
        let that = this //debugger
        let changeDiv = document.getElementsByClassName('goto-article')
        if (changeDiv && changeDiv.length != 0) {
          Array.from(changeDiv).forEach((item) => {
            item.style.color = 'blue'
            item.style.cursor = 'pointer'
            item.style.textDecoration = 'underline'
            item.onclick = function () {
              let str = { id: '', keyWord: this.keyWord }
              str.id = item.getAttribute('data-goto-article-id') //获取节点属性
              that.goDetail(str)
            }
          })
        }
      },
      goDetail(item) {
        let routeData = this.$router.resolve({
          path: '/content',
          query: {
            contentId: item.id + '',
            keyWord: this.keyWord,
          },
        })
        window.open(routeData.href, '_blank')
      },
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .midCommon{
    width: 100%;
    height:570px;
    overflow-y:auto ;
  }
  .contentBox {
    //width: calc(1200px - 240px);
    width: 100%;
    // height: calc(1340px - 70px);
    background: #fff;
    margin: 0 auto;
    padding: 20px;
    box-sizing: border-box;
    .title {
      line-height: 36px;
      // width: 790px;
      text-align: center;
      color: #3d3d3d;
      font-size: 18px;
      font-weight: 700;
    }
    .more {
      // height: 92px;
      margin: 20px 0;
      .time {
        color: #888;
        line-height: 24px;
        font-size: 16px;
        margin-bottom: 10px;
      }
      .time:last-child {
        margin-bottom: 0;
      }
    }
    .text {
      padding-top: 16px;
      border-top: 2px solid #d8d8d8;
      font-size: 16px;
      font-weight: normal;
      line-height: 32px;
      letter-spacing: 0em;
      color: #3d3d3d;
      padding-bottom: 20px;
    }
    .typeBoxs {
      .accessory {
        width: 100%;
        height: 40px;
        line-height: 40px;
        border-left: 6px solid #003fa8;
        background: #eef8ff;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 0em;
        color: #3d3d3d;
        margin-bottom: 15px;
      }
      .titleBox {
        width: calc(100% - 11px);
        padding-left: 11px;
        // height: 30px;
        margin-bottom: 10px;
        .title {
          font-size: 16px;
          font-weight: normal;
          line-height: 30px;
          letter-spacing: 0em;
          color: #0000ff;
        }
        .btn {
          width: 60px;
          height: 30px;
          font-size: 14px;
          font-weight: normal;
          line-height: 30px;
          letter-spacing: 0em;
          color: #fff;
          border-radius: 4px;
          background: #003fa8;
          display: inline-block;
          text-align: center;
          float: right;
        }
      }
    }
  }
  .vipText {
    margin-top: 25px;
    font-family: SourceHansansCN-Normal;
    font-size: 16px;
    text-align: center;
    color: #e62d2d;
    span {
      color: #2771e2 !important;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  ::v-deep .text table {
    width: 100%;
    border-color: #dfdfdf;
    border-collapse: collapse;
  }
  ::v-deep .text table tr td {
    text-align: center;
    padding: 0.5rem 0;
    border-color: #dfdfdf;
    border: 1px solid #dfdfdf;
  }
  </style>
  